import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";
import * as actions from "../../../../../../app/actions/generalActions";
import { useObjectsUIContext } from "../ObjectsUIContext";
import { useFilterObjectsUIContext } from "../FilterObjectsUIContext";

export function ObjectDeleteDialog({ api, id, show, onHide, currentState, softDelete }) {
  const objectsUIContext = useObjectsUIContext();
  const filterUIContext = useFilterObjectsUIContext();
  const objectsUIProps = useMemo(() => {
    return {
      setIds: objectsUIContext.setIds,
      queryParams: filterUIContext.queryParams,
    };
  }, [objectsUIContext, filterUIContext]);

  const dispatch = useDispatch();
  const { isLoading } = useSelector(
    (state) => ({ isLoading: currentState.actionsLoading }),
    shallowEqual
  );

  useEffect(() => {
    if (!id) {
      onHide();
    }

  }, [id]);

  const { name } = currentState;

  useEffect(() => { }, [isLoading, dispatch]);
  const deleteObject = () => {
    dispatch(actions.deleteObject(api, name, id, softDelete)).then(() => {
      dispatch(actions.fetchObjects(api, name, objectsUIProps.queryParams));
      objectsUIProps.setIds([]);
      onHide();
    });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {isLoading && <ModalProgressBar variant="query" />}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          غیرفعالسازی رکورد
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!isLoading && (
          <span>آیا از غیرفعالسازی اطمینان دارید؟</span>
        )}
        {isLoading && <span>در حال غیرفعالسازی...</span>}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            انصراف
          </button>
          <> </>
          <button
            type="button"
            onClick={deleteObject}
            className="btn btn-primary btn-elevate"
          >
            غیرفعالسازی
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
